export const constants = {
  INIT_MEMORY: 'BIOGRAPHICAL_EDITOR/INIT_MEMORY',
  INIT_MEMORY_SUCCESS: 'BIOGRAPHICAL_EDITOR/INIT_MEMORY_SUCCESS',
  INIT_MEMORY_FAIL: 'BIOGRAPHICAL_EDITOR/INIT_MEMORY_FAIL',

  GET_MEMORY: 'BIOGRAPHICAL_EDITOR/GET_MEMORY',
  GET_MEMORY_SUCCESS: 'BIOGRAPHICAL_EDITOR/GET_MEMORY_SUCCESS',
  GET_MEMORY_FAIL: 'BIOGRAPHICAL_EDITOR/GET_MEMORY_FAIL',

  SAVE_BLOCK: 'BIOGRAPHICAL_EDITOR/SAVE_BLOCK',
  SAVE_BLOCK_SUCCESS: 'BIOGRAPHICAL_EDITOR/SAVE_BLOCK_SUCCESS',
  SAVE_BLOCK_FAIL: 'BIOGRAPHICAL_EDITOR/SAVE_BLOCK_FAIL',

  GENERATE_MEMORY: 'BIOGRAPHICAL_EDITOR/GENERATE_MEMORY',
  GENERATE_MEMORY_SUCCESS: 'BIOGRAPHICAL_EDITOR/GENERATE_MEMORY_SUCCESS',
  GENERATE_MEMORY_FAIL: 'BIOGRAPHICAL_EDITOR/GENERATE_MEMORY_FAIL',

  POLL_STATUS: 'BIOGRAPHICAL_EDITOR/POLL_STATUS',
  POLL_STATUS_SUCCESS: 'BIOGRAPHICAL_EDITOR/POLL_STATUS_SUCCESS',
  POLL_STATUS_FAIL: 'BIOGRAPHICAL_EDITOR/POLL_STATUS_FAIL',

  SET_CURRENT_BLOCK: 'BIOGRAPHICAL_EDITOR/SET_CURRENT_BLOCK',
  RESET: 'BIOGRAPHICAL_EDITOR/RESET',
};

export const services = {
  initMemory: (lineId) => ({
    route: `/api/v2/lines/${lineId}/biographical-memory/init`,
    method: 'post',
    body: {},
  }),
  getMemory: (lineId, memoryUuid) => ({
    route: `/api/v2/lines/${lineId}/biographical-memory/${memoryUuid}`,
    method: 'get',
  }),
  saveBlock: (lineId, blockKey, answers, memoryUuid) => ({
    route: `/api/v2/lines/${lineId}/biographical-memory/${memoryUuid}/blocks`,
    method: 'post',
    body: { block_key: blockKey, answers },
  }),
  generateMemory: (lineId, memoryUuid) => ({
    route: `/api/v2/lines/${lineId}/biographical-memory/${memoryUuid}/generate`,
    method: 'post',
    body: {},
  }),
  pollStatus: (lineId, memoryUuid) => ({
    route: `/api/v2/lines/${lineId}/biographical-memory/${memoryUuid}/status`,
    method: 'get',
  }),
  saveText: (lineId, finalText, isPublic, memoryUuid) => ({
    route: `/api/v2/lines/${lineId}/biographical-memory/${memoryUuid}/draft`,
    method: 'put',
    body: { final_text: finalText, publish: isPublic ? 1 : 0 },
  }),
};

export const BLOCKS_CONFIG = [
  {
    key: 'context_and_roots',
    type: 'required',
    sortOrder: 1,
    icon: 'plant',
    iconColor: '#ACC64E',
  },
  {
    key: 'memories_and_anecdotes',
    type: 'required',
    sortOrder: 2,
    icon: 'camera',
    iconColor: '#8C88E7',
  },
  {
    key: 'family_relationships',
    type: 'required',
    sortOrder: 3,
    icon: 'heart',
    iconColor: '#E83060',
  },
  {
    key: 'farewell',
    type: 'required',
    sortOrder: 4,
    icon: 'sunrise',
    iconColor: '#F87818',
  },
  {
    key: 'personality_traits',
    type: 'optional',
    sortOrder: 5,
    icon: 'happy',
    iconColor: '#F698D7',
  },
  {
    key: 'adult_life_and_work',
    type: 'optional',
    sortOrder: 6,
    icon: 'briefcase',
    iconColor: '#5A56DC',
  },
  {
    key: 'values_and_legacy',
    type: 'optional',
    sortOrder: 7,
    icon: 'diamond',
    iconColor: '#5FB3FC',
  },
  {
    key: 'hobbies_and_personality',
    type: 'optional',
    sortOrder: 8,
    icon: 'music',
    iconColor: '#FEAE36',
  },
];

export const REQUIRED_BLOCKS = BLOCKS_CONFIG.filter((b) => b.type === 'required');

export const PLAN_TYPES = {
  FREE: 'free',
  PREMIUM: 'premium',
};

export const MEMORY_STATUS = {
  DRAFT: 'draft',
  READY: 'ready',
  GENERATING: 'generating',
  COMPLETED: 'completed',
};
